var map = {
	"./allaro-logo.png": 5555,
	"./designhood-admin-new-projects.png": 1141,
	"./designhood-client-create-order.png": 5573,
	"./designhood-client-messaging.png": 4602,
	"./designhood-client-payment-information.png": 5825,
	"./designhood-freelancer-project-card.png": 8268,
	"./designhood-freelancer-revision.png": 9176,
	"./designhood-freelancer-workplace1.png": 2385,
	"./designhood-freelancer-workplace2.png": 5833,
	"./designhood-logo.png": 9893,
	"./docs-dark@tinypng.1bbe175e.png": 2807,
	"./elca-logo.png": 1502,
	"./fitness-centre.png": 3156,
	"./hcmus-logo.png": 7914,
	"./llab-1.png": 9018,
	"./llab-2.png": 1920,
	"./llab-3.png": 5246,
	"./llab-4.png": 8846,
	"./llab-5.png": 1711,
	"./llab-6.png": 6407,
	"./llab-7.png": 526,
	"./llab-logo.png": 392,
	"./llab-order-page.png": 7598,
	"./logo.png": 4427,
	"./my-portfolio.png": 1762,
	"./optical-store.png": 9951,
	"./programming.png": 9377,
	"./tafe-logo.png": 7932,
	"./thrive-logo.png": 6289,
	"./zigvy-logo.png": 1817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;